/* Montaje al acercarse (29-10-2026). Sirve a sections/apps.liquid cuando su ajuste «lazy_mount» está encendido.
   Cada [data-lp-lazy-mount] lleva un <template> con los bloques de app; aquí se clona dentro del contenedor (los <script> de un template clonado SÍ se ejecutan al
   insertarse) cuando el contenedor entra en la franja de data-lp-lazy-margin píxeles (IntersectionObserver). Montaje inmediato: ancla en la URL, hashchange, falta de
   IntersectionObserver, impresión. La altura reservada (style min-height) se suelta cuando el bloque ya tiene alto o, como tope, a los 8 s (carrusel oculto por falta de reseñas). */
(function () {
  var cajas = document.querySelectorAll('[data-lp-lazy-mount]');
  if (!cajas.length) return;

  function soltar(caja) {
    caja.style.minHeight = '';
  }

  // Judge.me: su cargador (loader.js, del embed de la app) mira al abrir la página si hay algún widget y, solo entonces, trae las hojas y guiones que el widget necesita (las
  // estrellas, por ejemplo, dependen de su hoja base). Como el carrusel aún no estaba en la página, no trajo nada. Al montarlo se le deja ejecutarse otra vez (se baja su marca de
  // «ya ejecutado» y se vuelve a pedir el mismo fichero, que está en caché): ve el carrusel y hace lo mismo que habría hecho en la carga. Sin Judge.me, sin cargador o sin widget, no hace nada.
  function judgeme(caja) {
    try {
      var j = window.jdgm;
      if (!j || !j._loaderExecuted || !caja.querySelector('.jdgm-widget')) return;
      var tag = document.querySelector('script[src*="judgeme"][src*="/loader.js"]');
      if (!tag || !tag.src) return;
      j._loaderExecuted = false;
      var s = document.createElement('script');
      s.src = tag.src;
      document.head.appendChild(s);
    } catch (e) {}
  }

  function montar(caja) {
    if (caja.hasAttribute('data-lp-mounted')) return;
    caja.setAttribute('data-lp-mounted', '');
    var plantilla = caja.querySelector('template');
    if (!plantilla) return soltar(caja);
    try {
      caja.appendChild(plantilla.content.cloneNode(true));
    } catch (e) {
      soltar(caja);
      return;
    }
    plantilla.parentNode.removeChild(plantilla);
    judgeme(caja);
    if (!caja.style.minHeight) return;
    var fin = setTimeout(function () { soltar(caja); }, 8000);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        if (caja.firstElementChild && caja.firstElementChild.offsetHeight > 0) {
          clearTimeout(fin);
          ro.disconnect();
          soltar(caja);
        }
      });
      if (caja.firstElementChild) ro.observe(caja.firstElementChild);
    }
  }

  function montarTodas() {
    Array.prototype.forEach.call(cajas, montar);
  }

  if (location.hash || !('IntersectionObserver' in window)) {
    montarTodas();
  } else {
    var observadores = [];
    Array.prototype.forEach.call(cajas, function (caja) {
      var margen = parseInt(caja.getAttribute('data-lp-lazy-margin'), 10) || 1200;
      var io = new IntersectionObserver(function (entradas) {
        if (entradas.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          montar(caja);
        }
      }, { rootMargin: margen + 'px 0px' });
      io.observe(caja);
      observadores.push(io);
    });
    addEventListener('hashchange', montarTodas);
    addEventListener('beforeprint', montarTodas);
  }
})();
